import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AUTH_TOKEN } from '@app/_interceptors/auth.interceptor';
import { APP_PATH } from '@app/app.constants';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(private router: Router) {}

    // @ts-ignore-start: игнарируем неиспользуемый параметр "route"
    // так как без него canActivate не хочет работать
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (localStorage.getItem(AUTH_TOKEN)) {
            return true;
        }

        this.router.navigate([APP_PATH.login], { queryParams: { returnUrl: state.url } });
        return false;
    }
}
